import { render, staticRenderFns } from "./NotificationPetugasOmbro.vue?vue&type=template&id=776faf38&"
import script from "./NotificationPetugasOmbro.vue?vue&type=script&lang=js&"
export * from "./NotificationPetugasOmbro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports